import Vue from 'vue'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueResource from 'vue-resource'

import Mint from 'mint-ui'
import * as qiniu from 'qiniu-js'

import App from './App.vue'

import i18n from "./language";
import router from './router/index'
import store from './store/index'
import utils from './util/util'
import validator from './util/validator'
import wxApi from './util/wxapi'
import VueAppend from 'vue-append'
import VeHistogram from 'v-charts/lib/histogram.common'

import Cookies from 'js-cookie'

import 'swiper/dist/css/swiper.css'
import 'mint-ui/lib/style.css'
import './assets/style/reset.scss'
import './assets/style/common.scss'
import './assets/style/my-mint.scss'

Vue.config.productionTip = false

// 使用moment处理日期格式
import Moment from 'moment'
Vue.filter('convertTime', function (timeStr) {
	return Moment(timeStr).format('YYYY-MM-DD HH:mm:ss')
})

// let locales = 'zh-CN'
// let currency = 'CNY'
// if(env.LOCALES) {
// 	locales = env.LOCALES
// }
// if(env.CURRENCY) {
// 	currency = env.CURRENCY
// }
const default_currency = {
	locales: env.LOCALES,
	currency: env.CURRENCY,
	rate: 1
}
let navigator_currency = null
const navigatorLanguage = navigator.language
const numberFormat = Object.values(env.numberFormat)
for (const item of numberFormat) {
	if (navigatorLanguage.indexOf(item.locales) > -1) {
		navigator_currency = item
		break
	}
}
if(navigator_currency === null) {
	navigator_currency = default_currency
}

Vue.filter('convertCurrency', function (amount) {
	let language = null
	if(localStorage.getItem('commodity_currency') === '1') {
		language = default_currency
	}
	else {
		language = navigator_currency
	}
	const rateAmount = amount * language.rate
	return new Intl.NumberFormat(language.locales, { style: 'currency', currency: language.currency }).format(rateAmount)
})

Vue.filter('formatCurrency', function (amount) {
	if(amount == '') {
		amount = 0;
	}
	return parseFloat(amount).toLocaleString();
})

router.beforeEach((to, from, next) => {
	let metaData = to.meta;
	if (metaData.setIsShowTabBar) {
		for (const key in to.params) {
			if (key == metaData.setIsShowTabBar) {
				metaData.isshowtabbar = parseInt(to.params[metaData.setIsShowTabBar]);
			}
		}
	}
	next();
});

Vue.use(Mint)
Vue.use(VueResource)
Vue.use(VueAwesomeSwiper)
Vue.use(qiniu)
Vue.use(VueAppend);
Vue.component(VeHistogram.name, VeHistogram);

Vue.prototype.utils = utils;
Vue.prototype.validator = validator;
Vue.prototype.wxApi = wxApi;
Vue.prototype.$cookie = Cookies;


window.router = router;

new Vue({
	i18n,
	router,
	store,
	render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js